import { render } from "./customer_consent.html?vue&type=template&id=d5788980&external"
import script from "./customer_consent.js?vue&type=script&lang=js&external"
export * from "./customer_consent.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__